import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"panorama-horizontal"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M22 4.5L22 19.5C22 19.5 17 18 12 18C7 18 2 19.5 2 19.5L2 4.5C2 4.5 7 6 12 6C17 6 22 4.5 22 4.5Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M22 4.5L22 19.5C22 19.5 17 18 12 18C7 18 2 19.5 2 19.5L2 4.5C2 4.5 7 6 12 6C17 6 22 4.5 22 4.5Z","strokeWidth":"props.strokeWidth"}}]}]};

const PanoramaHorizontal = Vue.extend<IconProps>({
  name: 'PanoramaHorizontalIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'panorama-horizontal',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default PanoramaHorizontal;
